import React, { useState, useMemo, useEffect, useRef, Dispatch } from "react";
import {
  Stack,
  VStack,
  HStack,
  Text,
  Box,
  Pressable,
  Center,
  Button,
  Progress,
  Divider,
  Icon,
  Checkbox,
  Input,
  IconButton,
} from "native-base";
import _ from "lodash";
import Moment from "moment";
import * as AV from "../../../AVCore/AVCore";
import { CloseIcon, SearchIcon } from "native-base";
import ProfilePic from "../../common/ProfilePicture";
import EntityProfilePic from "../../common/EntityProfilePic";
import { Loader } from "../../../components/loaders";
import { Loc } from "../../../App/Loc";
import { RootStateOrAny, useSelector, useDispatch } from "react-redux";
import {
  setSearch,
  setUser,
  setEntitydata,
} from "../../../Redux/Actions/userActions";
import { setPlanOrgStorage } from "../../../Redux/Actions/myPlanActions";
import { useNavigate } from "react-router-dom";
import PurchaseCreditsPopup from "../../../components/common/PurchaseCreditsPopup";
import { DollarCoinsIcon } from "../../../assets/icons/icon-assets";
import { AiOutlineInfoCircle } from "react-icons/ai"; // for info icon
import { Dimensions } from "react-native";
import { useWindowDimension } from "../../../Utility/WindowDimensions";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import CustomToast from "../../../Hooks/useCustomToast";
import AVConfirmationModal from "../../../components/common/AVConfirmationModal";

interface Props {
  entity?: AV.IAVEntity;
  setEntity?: Dispatch<React.SetStateAction<AV.IAVEntity>>;
  sharedPlan?: AV.ISharedPlan;
  setSharedPlan?: (sharedPlan?: AV.ISharedPlan) => void;
  triggerBuyCredits?: boolean;
  setTriggerBuyCredits?: (val: boolean) => void;
}

interface ConfirmationPopupProps {
  type: string;
  isAPICall: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
}

type EntityStorageResponse = {
  plan?: {
    storeUsed?: number;
    storeLimit?: number;
    credits?: number;
    baseStoreLimit?: number;
  };
};

function MyPlan({
  entity,
  setEntity,
  sharedPlan,
  setSharedPlan,
  triggerBuyCredits,
  setTriggerBuyCredits,
}: Props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dimensions = useWindowDimension();
  const dimension = Dimensions.get("window");
  const mobile = dimensions?.width < 600 || false;
  const isMobile = dimension?.width <= 500 || false;
  const currentUser = useSelector(
    (state: RootStateOrAny) => state?.user?.user[0],
  );
  const localUserSearch = useSelector(
    (state: RootStateOrAny) => state.user.userSearch,
  );
  const entityDataList = useSelector(
    (state: RootStateOrAny) => state.user.entitydatalist,
  );
  const orgStorage = useSelector(
    (state: RootStateOrAny) => state.myplan.orgStorage,
  );

  const finalEntity = entity || currentUser;
  const fk: AV.IFK = AV.AVEntity.getFk(finalEntity);

  const [loading, setLoading] = useState(true);
  const [isAPICall, setIsAPICall] = useState(false);
  const [isBuyStorage, setIsBuyStorage] = useState(false);
  const [showCreditsPopup, setShowCreditsPopup] = useState(false);
  const [creditsAvailable, setCreditsAvailable] = useState<number>(
    finalEntity?.plan?.credits ?? 0,
  );
  const [showAddSharePopup, setShowAddSharePopup] = useState(false);
  const [showShareMyPlanPopup, setShowShareMyPlanPopup] = useState(false);
  const [shareTypeValue, setShareTypeValue] = useState(
    sharedPlan?.autoShareType ?? "none",
  );
  const [isManagePlan, setIsManagePlan] = useState(false);
  const [isAutoShareChild, setIsAutoShareChild] = useState(false);
  const [isConfirm, setIsConfirm] = useState(false);
  const [confirmType, setConfirmType] = useState("");
  //const [searchInput, setSearchInput] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [suggestions, setSuggestions] = useState<AV.ILink[]>([]);
  const [searchResults, setSearchResults] = useState<AV.ILink[]>([]);
  const [selectedOrgs, setSelectedOrgs] = useState<AV.ILink[]>([]);
  const [removedOrgs, setRemovedOrgs] = useState<AV.ILink | null>(null);
  //const staffList = (entity as any)?.staff as { id: string }[] | undefined;
  //const isOwner =
  //sharedPlan?.owner?.type === "Person"
  //  ? sharedPlan?.owner?.id === currentUser?.id
  //  : !!staffList?.some(staff => staff.id === currentUser?.id);
  const [isOwner, setIsOwner] = useState(
    sharedPlan?.owner?.id === finalEntity?.id,
  );

  useEffect(() => {
    if (sharedPlan) {
      //setCreditsAvailable(sharedPlan?.plan?.credits ?? 0);
      setShareTypeValue(sharedPlan?.autoShareType ?? "none");
      setIsOwner(sharedPlan?.owner?.id === finalEntity?.id);
      //setSharedOrgs(sharedPlan?.shared ?? []);
      //setLoading(false);
    }
    //setLoading(false);
  }, [setSharedPlan]);

  useEffect(() => {
    let isMounted = true;

    handleGetSharedPlan();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    if (!showShareMyPlanPopup) {
      setIsManagePlan(false);
      setShareTypeValue(sharedPlan?.autoShareType ?? "none");
    }
  }, [showShareMyPlanPopup]);

  useEffect(() => {
    if (entity || currentUser) {
      setCreditsAvailable(
        entity
          ? (entity?.plan?.credits ?? 0)
          : (currentUser?.plan?.credits ?? 0),
      );
    }
  }, [entity, currentUser]);

  useEffect(() => {
    let isMounted = true;

    if (
      triggerBuyCredits &&
      sharedPlan?.owner?.id === finalEntity?.id &&
      isMounted
    ) {
      setShowCreditsPopup(true);
      setTimeout(() => {
        if (isMounted) setTriggerBuyCredits?.(false);
      }, 0);
    }

    return () => {
      isMounted = false;
    };
  }, [triggerBuyCredits]);

  function formatBytes(bytes: number) {
    if (bytes === -1) return "0MB"; // handle unknown value
    const sizes = ["B", "KB", "MB", "GB", "TB"];
    if (bytes === 0) return "0B";
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return `${parseFloat((bytes / Math.pow(1024, i)).toFixed(2))}${sizes[i]}`;
  }

  const handleSharePlan = async () => {
    try {
      if (!fk?.id) return;
      setIsAPICall(true);

      const param: AV.IPlanNewParam = {
        source: fk,
        autoShare: shareTypeValue === "none" ? null : shareTypeValue,
      };

      const result = await AV.Plan.sharePlan(param);
      console.log("Shared Plan created:", result);
      setSharedPlan?.(result);
      //setCreditsAvailable(result?.plan?.credits ?? 0);
      setShareTypeValue(result?.autoShareType ?? "none");
      //setSharedOrgs(result?.shared ?? []);
      setIsOwner(true);
    } catch (error) {
      console.error("Error creating shared plan:", error);
    } finally {
      setIsAPICall(false);
      setShowShareMyPlanPopup(false);
    }
  };

  const handleGetSharedPlan = async () => {
    try {
      if (!fk?.id) return;

      const sharedPlan: AV.ISharedPlan = await AV.AVEntity.getSharedPlan(fk);
      setSharedPlan?.(sharedPlan);
      //setCreditsAvailable(sharedPlan?.plan?.credits ?? 0);
      setShareTypeValue(sharedPlan?.autoShareType ?? "none");
      //setSharedOrgs(sharedPlan?.shared ?? []);
    } catch (error) {
      console.error("Failed to fetch plan:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSaveSharedPlan = async (sharedPlan: AV.ISharedPlan) => {
    try {
      setIsAPICall(true);

      sharedPlan.autoShareType =
        shareTypeValue === "none" ? null : shareTypeValue;
      const updatedPlan: AV.ISharedPlan = await AV.Plan.save(sharedPlan);
      console.log("Shared plan saved:", updatedPlan);

      setSharedPlan?.(updatedPlan);
      //setCreditsAvailable(updatedPlan?.plan?.credits ?? 0);
      setShareTypeValue(updatedPlan?.autoShareType ?? "none");
      //setSharedOrgs(updatedPlan?.shared ?? []);
    } catch (err) {
      console.error("Failed to save shared sharedPlan:", err);
    } finally {
      setIsAPICall(false);
      setIsManagePlan(false);
      setShowShareMyPlanPopup(false);
    }
  };

  // Leave Plan
  const handleStopShare = async () => {
    try {
      if (!fk?.id) return;
      setIsAPICall(true);

      const result = await AV.Plan.stopShare(fk);
      console.log("Plan sharing stopped, updated entity:", result);

      setSharedPlan?.(undefined);
      //setCreditsAvailable(0);
      setShareTypeValue("none");
      //setSharedOrgs([]);
    } catch (err) {
      console.error("StopShare failed:", err);
    } finally {
      setIsAPICall(false);
      setIsConfirm(false);
    }
  };

  const handleShareWith = async () => {
    try {
      if (!fk?.id) return;
      setIsAPICall(true);

      const param: AV.IPlanShareParam = {
        source: fk,
        target: selectedOrgs as AV.ITypeLink[],
        shareType: "",
      };

      const updatedPlan = await AV.Plan.shareWith(param);
      console.log("Plan shared with targets:", updatedPlan);

      setSharedPlan?.(updatedPlan);
      //setCreditsAvailable(updatedPlan?.plan?.credits ?? 0);
      setShareTypeValue(updatedPlan?.autoShareType ?? "none");
      //setSharedOrgs(updatedPlan?.shared ?? []);
    } catch (err) {
      console.error("Failed to share plan:", err);
    } finally {
      clearSearch();
      setIsAPICall(false);
      setShowAddSharePopup(false);
    }
  };

  // Remove
  const handleUnshare = async () => {
    try {
      if (!fk?.id) return;
      setIsAPICall(true);

      const param: AV.ITypeLinkListParam = {
        source: fk,
        target: [removedOrgs as AV.ITypeLink],
      };

      const updatedPlan = await AV.Plan.unshare(param);
      console.log("Shared plan after unsharing:", updatedPlan);

      setSharedPlan?.(updatedPlan);
      //setCreditsAvailable(updatedPlan?.plan?.credits ?? 0);
      setShareTypeValue(updatedPlan?.autoShareType ?? "none");
      //setSharedOrgs(updatedPlan?.shared ?? []);
    } catch (err) {
      console.error("Unshare failed:", err);
    } finally {
      setIsAPICall(false);
      setIsConfirm(false);
    }
  };

  const fetchOrgStorage = async (org: AV.ILink) => {
    const key = String(org?.id ?? "");

    try {
      const response = (await AV.AVEntity.get(org)) as EntityStorageResponse;
      const storage = {
        storeUsed: response?.plan?.storeUsed ?? 0,
        storeLimit: response?.plan?.storeLimit ?? 0,
      };

      dispatch(setPlanOrgStorage(key, storage));
    } catch (err) {
      console.error("Error fetching storage for org:", org.id, err);
      dispatch(setPlanOrgStorage(key, null)); // fallback
    }
  };

  const handleSearchItems = async (searchValue: string) => {
    setSearchQuery(searchValue);

    if (searchValue.length >= 1) {
      try {
        // Get search results from AV.Person.search
        const searchData = await AV.Person.localSearch(searchValue);
        let results = (searchData || []) as AV.ILink[];
        const query = searchValue.toLowerCase();

        // Filter and transform the results
        results = results.filter(
          (x) =>
            x?.title !== undefined &&
            x?.data !== "Deleted" &&
            x?.data !== "Suspended" &&
            x.type != "Channel" &&
            (x?.title?.toLowerCase().includes(query) ||
              x?.data?.toLowerCase().includes(query)),
        );

        // Include dependents (wards)
        const wardMatches =
          currentUser?.wards?.filter(
            (x) =>
              x?.title &&
              (x.title.toLowerCase().includes(query) ||
                x.data?.toLowerCase().includes(query)),
          ) ?? [];

        results = results.concat(wardMatches);

        // Remove blocked users and channels
        results = results.filter(
          (x) => !currentUser?.blocked?.some((y: AV.ILink) => y?.id === x?.id),
        );

        // Remove already shared orgs
        results = results.filter(
          (x) => !sharedPlan?.shared?.some((y: AV.ILink) => y?.id === x?.id),
        );

        // Remove already selected orgs
        results = results.filter(
          (x) => !selectedOrgs?.some((y: AV.ILink) => y?.id === x?.id),
        );

        // Remove duplicates and format for display
        const formattedResults = _.uniqBy(results, "id");

        setSearchResults(formattedResults);
        setSuggestions(formattedResults);

        let locSearch = localUserSearch;
        if (locSearch == undefined) locSearch = [];
        locSearch = locSearch.concat(results);
        locSearch = locSearch?.filter(
          (x) => !currentUser?.blocked?.some((y) => y?.id === x?.id),
        );
        locSearch = _.uniqBy(locSearch, "id");
        dispatch(setSearch(locSearch));
      } catch (error) {
        console.error("Error searching orgs:", error);
        setSearchResults([]);
        setSuggestions([]);
      }
    } else {
      setSearchResults([]);
      setSuggestions([]);
    }
  };

  const clearSearch = () => {
    setSearchQuery("");
    setSuggestions([]);
    setSearchResults([]);
    setSelectedOrgs([]);
    setIsSearching(false);
  };

  const handleOrgSelect = async (org: AV.ILink) => {
    let entity = entityDataList?.find((x) => x?.id === org?.id) ?? null;

    if (!entity) {
      entity = await AV.AVEntity.get(org);
      entityDataList?.push(entity);
      dispatch(setEntitydata(entityDataList));
    }

    if (entity?.plan?.shared) {
      let clientError = {
        message: Loc.currentLang.myPlan.alreadySharedError,
      };
      CustomToast({ clientError });

      return;
    }

    setSelectedOrgs((prevOrgs) => {
      // Avoid duplicates
      if (prevOrgs.some((o) => o.id === org.id)) {
        return prevOrgs;
      }
      return [...prevOrgs, org];
    });

    setSearchQuery("");
    setSuggestions([]);
    setSearchResults([]);
  };

  const handleRemoveOrg = (orgId: string) => {
    setSelectedOrgs(selectedOrgs.filter((o) => o.id !== orgId));
  };

  // -----------------------------
  // SharedPlanCard internal component
  // -----------------------------

  const SearchBox: React.FC<{
    searchInput: string;
    onSearchChange: (val: string) => void;
    onClearSearch: () => void;
    isMobile: boolean;
  }> = ({ searchInput, onSearchChange, onClearSearch, isMobile }) => {
    const inputRef = useRef<HTMLInputElement | null>(null);

    return (
      <Box mb={6} position="relative" zIndex={10}>
        <HStack space={2} alignItems="center">
          <Input
            width={isMobile ? "200px" : "267px"}
            height="34px"
            overflow="hidden"
            borderWidth={0}
            value={searchInput}
            placeholder={Loc.currentLang.myPlan.search}
            variant="AVSearchInput"
            placeholderTextColor="AVColor.textLite"
            backgroundColor="#F5F5F5"
            borderRadius="22px"
            fontSize="16px"
            InputLeftElement={
              <SearchIcon ml="2" size="24px" color="#000" left="10px" p="7px" />
            }
            InputRightElement={
              searchInput ? (
                <IconButton
                  icon={<CloseIcon size="xs" />}
                  size="sm"
                  variant="AVSearchInput"
                  onPress={() => {
                    onClearSearch();
                    inputRef.current?.focus();
                  }}
                  _hover={{ bg: "transparent" }}
                />
              ) : undefined
            }
            onChangeText={(val) => {
              onSearchChange(val);
              inputRef.current?.focus();
            }}
          />
        </HStack>
      </Box>
    );
  };

  const SharedOrgsList: React.FC<{
    sharedOrgs: (AV.ILink & { storeUsed?: number; storeLimit?: number })[];
    currentUser: AV.IAVEntity | null;
    entityDataList: AV.IAVEntity[];
    onRemove: (org: AV.ILink) => void;
  }> = ({ sharedOrgs, currentUser, entityDataList, onRemove }) => {
    return (
      <Box mt={2} flex={1} maxHeight={250} overflow="scroll">
        <VStack space={3}>
          {sharedOrgs.map((item) => (
            <HStack
              key={item.id}
              alignItems="center"
              justifyContent="space-between"
              borderBottomWidth={1}
              borderColor="coolGray.100"
              pb={2}
            >
              {/* Left Section: Avatar + Name */}
              <HStack alignItems="center" space={3} flex={1}>
                <Box
                  size={8}
                  borderRadius="full"
                  bg="coolGray.200"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Pressable
                    position={"absolute"}
                    onPress={() => {
                      switch (item?.type) {
                        //case "PlayerOrg":
                        //  navigate(`/season/${item?.id}/${item?.region}`, {
                        //    state: { isCreate: false, team: item },
                        //  });
                        //  break;
                        //case "Team":
                        //case "Group":
                        //  navigate(`/teams/${item?.id}/${item?.region}`, {
                        //    state: { isCreate: false, team: item },
                        //  });
                        //  break;
                        case "Person":
                        case "Pet":
                          navigate(`/profile/${item?.id}/${item?.region}`, {
                            state: {
                              user: {
                                id: item?.id,
                                pk: item?.pk,
                                region: item?.region,
                                type: item?.type,
                                name: item?.title,
                              },
                            },
                          });
                          break;
                        default:
                          navigate(`/teams/${item?.id}/${item?.region}`, {
                            state: { isCreate: false, team: item },
                          });
                          break;
                      }
                    }}
                  >
                    {item?.type === "Person" ? (
                      <ProfilePic
                        width="32px"
                        height="32px"
                        link={
                          currentUser && currentUser.id === item?.id
                            ? AV.AVEntity.getLink(currentUser)
                            : (() => {
                                const entity = entityDataList?.find(
                                  (x) => x?.id === item?.id,
                                );
                                return entity
                                  ? AV.AVEntity.getLink(entity)
                                  : item;
                              })()
                        }
                      />
                    ) : (
                      <EntityProfilePic
                        width="35px"
                        height="35px"
                        link={(() => {
                          const entity = entityDataList?.find(
                            (x) => x?.id === item?.id,
                          );
                          return entity
                            ? (AV.AVEntity.getLink(entity) ?? {
                                ...item,
                                type: item?.type,
                              })
                            : item;
                        })()}
                      />
                    )}
                  </Pressable>
                </Box>

                <VStack>
                  <Text fontSize="sm" fontWeight="medium">
                    {item?.type === "Channel"
                      ? item?.title
                      : item?.data || item?.title}
                  </Text>
                </VStack>
              </HStack>

              {/* Right Section: Storage + Remove Button */}
              <HStack alignItems="center" space={4}>
                {orgStorage[String(item?.id ?? "")] ? (
                  <Text fontSize="12px" fontWeight="medium">
                    <Text color="#00A7BC">
                      {formatBytes(
                        orgStorage[String(item?.id ?? "")]?.storeUsed ?? 0,
                      )}
                    </Text>
                    <Text color="#00000080">
                      {" / "}
                      {formatBytes(
                        orgStorage[String(item?.id ?? "")]?.storeLimit ?? 0,
                      )}
                    </Text>
                  </Text>
                ) : (
                  <Pressable onPress={() => fetchOrgStorage(item)}>
                    <Text fontSize="sm" color="#00A6BC" underline>
                      {Loc.currentLang.myPlan.viewStorage}
                    </Text>
                  </Pressable>
                )}

                <Button
                  size="sm"
                  rounded="full"
                  backgroundColor="AVColor.primary"
                  onPress={() => onRemove(item)}
                >
                  {Loc.currentLang.myPlan.remove}
                </Button>
              </HStack>
            </HStack>
          ))}
        </VStack>
      </Box>
    );
  };

  const SharedPlanCard: React.FC = () => {
    const [searchInput, setSearchInput] = useState("");
    const [sharedOrgs, setSharedOrgs] = useState<
      (AV.ILink & { storeUsed?: number; storeLimit?: number })[]
    >(sharedPlan?.shared ?? []);

    const handleSearchChange = (val: string) => {
      setSearchInput(val);
      const searchText = val.trim().toLowerCase();

      const filteredSharedOrg =
        searchText.length > 0
          ? (sharedPlan?.shared?.filter(
              (x) =>
                x?.data?.toLowerCase().includes(searchText) ||
                x?.title?.toLowerCase().includes(searchText),
            ) ?? [])
          : (sharedPlan?.shared ?? []);

      setSharedOrgs(filteredSharedOrg);
    };

    const handleClearSearch = () => {
      setSearchInput("");
      setSharedOrgs(sharedPlan?.shared ?? []);
    };

    const handleRemoveOrg = (org: AV.ILink) => {
      setIsConfirm(true);
      setConfirmType("UnShare");
      setRemovedOrgs(org);
    };

    return (
      <VStack space={4} w="100%">
        {/* Header */}
        <HStack justifyContent="space-between" alignItems="center">
          {/* Left side */}
          <Text fontSize="md" fontWeight="bold">
            {Loc.currentLang.myPlan.sharedPlan}
          </Text>

          {/* Right side */}
          <HStack space={4} alignItems="center">
            {/*{isOwner && (*/}
            {/*  <Pressable*/}
            {/*    onPress={() => {*/}
            {/*      setIsConfirm(true);*/}
            {/*      setConfirmType("StopShare");*/}
            {/*    }}*/}
            {/*  >*/}
            {/*    <Text fontSize="md" color="#00A6BC" underline>*/}
            {/*      {Loc.currentLang.myPlan.unShareMyplan}*/}
            {/*    </Text>*/}
            {/*  </Pressable>*/}
            {/*)}*/}

            <Button
              size="sm"
              rounded="full"
              backgroundColor="AVColor.primary"
              onPress={() => {
                if (isOwner) {
                  setIsManagePlan(true);
                  setShowShareMyPlanPopup(true);
                  setShareTypeValue(sharedPlan?.autoShareType ?? "none");
                } else {
                  setIsConfirm(true);
                  setConfirmType("LeaveShare");
                }
              }}
            >
              {isOwner
                ? Loc.currentLang.myPlan.managePlanCaps
                : Loc.currentLang.myPlan.leavePlan}
            </Button>
          </HStack>
        </HStack>

        {/* Credits + Storage Cards */}
        <HStack space={2}>
          {/* Credits Card */}
          <Box
            flex={1}
            borderWidth={1}
            borderColor="coolGray.200"
            borderRadius="xl"
            p={3}
            bg="white"
            shadow={1}
            justifyContent="space-between"
          >
            <VStack
              flex={1}
              justifyContent="space-between"
              space={3}
              alignItems="center"
            >
              <HStack w="full" justifyContent="flex-start">
                <Text fontSize="md" fontWeight="bold">
                  {Loc.currentLang.myPlan.credits}
                </Text>
              </HStack>

              <DollarCoinsIcon height="90px" width="90px" />

              <Text fontSize="2xl" fontWeight="bold">
                {sharedPlan?.plan?.credits ?? 0}
              </Text>

              <Text fontSize="16px" fontWeight="bold">
                {Loc.currentLang.myPlan.availableCredits}
              </Text>

              {isOwner && (
                <>
                  <Text textAlign="center" fontSize="xs" color="coolGray.400">
                    {Loc.currentLang.myPlan.earnMoreCredits}
                  </Text>

                  <Button
                    mt={2}
                    w="full"
                    rounded="full"
                    bg="AVColor.primary"
                    _pressed={{ bg: "#289966" }}
                    onPress={() => {
                      setIsBuyStorage(false);
                      setShowCreditsPopup(true);
                    }}
                  >
                    {Loc.currentLang.manageConversation.buyMoreCredits}
                  </Button>
                </>
              )}
            </VStack>
          </Box>

          {/* Storage Card */}
          <Box
            flex={1}
            borderWidth={1}
            borderColor="coolGray.200"
            borderRadius="xl"
            p={3}
            bg="white"
            shadow={1}
            justifyContent="space-between"
          >
            <VStack flex={1} justifyContent="space-between" space={3}>
              <Text fontSize="md" fontWeight="bold">
                {Loc.currentLang.myPlan.storage}
              </Text>

              <Text fontSize="sm" fontWeight="medium">
                <Text fontSize="12px" fontWeight="bold">
                  {formatBytes(sharedPlan?.plan?.storeUsed ?? 0)}{" "}
                </Text>
                <Text fontSize="xs" color="coolGray.400">
                  {Loc.currentLang.myPlan.ofShared}{" "}
                  {formatBytes(sharedPlan?.plan?.storeLimit ?? 0)}
                </Text>
              </Text>

              <Progress
                value={
                  ((sharedPlan?.plan?.storeUsed ?? 0) /
                    (sharedPlan?.plan?.storeLimit ?? 1)) *
                  100
                }
                size="sm"
                _filledTrack={{ bg: "#00A7BC" }}
              />

              <HStack alignItems="center" mt={1}>
                <Pressable onPress={() => navigate("/donate")}>
                  <Text fontSize="14px" color="blue.500" underline>
                    {Loc.currentLang.purchaseCredits.donationLink}
                  </Text>
                </Pressable>
              </HStack>

              {isOwner && (
                <Button
                  mt={2}
                  w="full"
                  rounded="full"
                  bg="AVColor.primary"
                  _pressed={{ bg: "#289966" }}
                  onPress={() => {
                    setIsBuyStorage(true);
                    setShowCreditsPopup(true);
                  }}
                >
                  {Loc.currentLang.myPlan.buyMoreStorage}
                </Button>
              )}
            </VStack>
          </Box>
        </HStack>

        {/* Shared With */}
        {isOwner && (
          <>
            <HStack justifyContent="space-between" alignItems="center">
              {/* Left side */}
              <Text fontSize="md" fontWeight="bold">
                {Loc.currentLang.myPlan.sharedWith}
              </Text>

              {/* Right side Search + Add */}
              <HStack space={4} alignItems="center">
                <SearchBox
                  searchInput={searchInput}
                  onSearchChange={handleSearchChange}
                  onClearSearch={handleClearSearch}
                  isMobile={isMobile}
                />

                {/* + Add button */}
                <Pressable
                  top="-15px"
                  onPress={() => setShowAddSharePopup(true)}
                >
                  <Text fontSize="md" color="#00A6BC" underline>
                    + {Loc.currentLang.myPlan.add}
                  </Text>
                </Pressable>
              </HStack>
            </HStack>

            {/* Shared With List */}
            {sharedOrgs.length === 0 ? (
              <Box py={4} alignItems="center">
                <Text fontSize="sm" color="coolGray.500">
                  {Loc.currentLang.menu.noRecordsFound}
                </Text>
              </Box>
            ) : (
              <SharedOrgsList
                sharedOrgs={sharedOrgs}
                currentUser={currentUser}
                entityDataList={entityDataList}
                onRemove={handleRemoveOrg}
              />
            )}
          </>
        )}
      </VStack>
    );
  };

  // -----------------------------
  // ConfirmationPopup internal component
  // -----------------------------
  const ConfirmationPopup: React.FC<ConfirmationPopupProps> = ({
    type,
    isAPICall,
    onClose,
    onConfirm,
  }) => {
    return (
      <Box
        position="fixed"
        top={0}
        left={0}
        right={0}
        bottom={0}
        bg="rgba(0,0,0,0.4)"
        zIndex={9999}
        justifyContent="center"
        alignItems="center"
      >
        <VStack
          bg="white"
          width={["90%", "600px"]}
          borderRadius="12px"
          shadow={2}
          p={5}
          space={4}
        >
          <HStack justifyContent="space-between" alignItems="center">
            <Text fontSize="lg" fontWeight="bold">
              {Loc.currentLang.myPlan.confirmation}
            </Text>
          </HStack>

          <Text fontSize="md" color="gray.700">
            {type === "StopShare"
              ? Loc.currentLang.myPlan.confirmationUnshareInfo
              : type === "LeaveShare"
                ? Loc.currentLang.myPlan.confirmationLeavePlanInfo
                : Loc.currentLang.myPlan.confirmationRemoveInfo}
          </Text>

          <HStack
            marginTop={"2%"}
            space={5}
            justifyContent={isMobile ? "flex-start" : "center"}
            alignSelf="center"
            flexWrap="wrap"
            maxWidth="100%"
          >
            <Button
              rounded="full"
              width="140px"
              height="40px"
              paddingTop="5px"
              paddingBottom="5px"
              backgroundColor="gray.300"
              onPress={onClose}
            >
              <Text fontSize="16px" color="black">
                {Loc.currentLang.myPlan.cancel}
              </Text>
            </Button>

            <Button
              rounded="full"
              width="140px"
              height="40px"
              paddingTop="5px"
              paddingBottom="5px"
              bg="AVColor.primary"
              isLoading={isAPICall}
              onPress={onConfirm}
            >
              {type === "StopShare"
                ? Loc.currentLang.myPlan.unSharePlan
                : type === "LeaveShare"
                  ? Loc.currentLang.myPlan.leavePlan
                  : Loc.currentLang.myPlan.remove}
            </Button>
          </HStack>
        </VStack>
      </Box>
    );
  };

  return (
    <>
      <Box
        bg="white"
        p={loading ? "280" : isOwner ? "6" : "2"}
        borderRadius="lg"
        shadow="sm"
        width="100%"
        maxWidth={sharedPlan ? "unset" : "800px"}
        height={sharedPlan ? "unset" : "calc(100vh - 150px)"}
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
      >
        {loading ? (
          <Box position="absolute" top="40%" left="40%" m={5}>
            <Loader />
          </Box>
        ) : (
          <>
            <VStack flex={1} bg="white">
              {/* Header */}
              {!sharedPlan && (
                <HStack
                  justifyContent="space-between"
                  alignItems="center"
                  mb={4}
                >
                  <Text fontSize="md" fontWeight="bold">
                    {Loc.currentLang.menu.myPlan}
                  </Text>

                  {!sharedPlan && (
                    <Pressable onPress={() => setShowShareMyPlanPopup(true)}>
                      <Text fontSize="md" color="#00A6BC" underline>
                        {Loc.currentLang.myPlan.shareMyplan}
                      </Text>
                    </Pressable>
                  )}
                </HStack>
              )}

              {/* Row: Credits + Storage */}
              {!sharedPlan && (
                <HStack space={4}>
                  {/* Credits Card */}
                  <Box
                    flex={1}
                    borderWidth={1}
                    borderColor="coolGray.200"
                    borderRadius="xl"
                    p={3}
                    bg="white"
                    shadow={1}
                  >
                    <Text fontSize="md" fontWeight="bold">
                      {Loc.currentLang.myPlan.credits}
                    </Text>
                    <VStack space={3} alignItems="center">
                      <DollarCoinsIcon height="90px" width="90px" />
                      <Text fontSize="2xl" fontWeight="bold">
                        {creditsAvailable}
                      </Text>
                      <Text fontSize="16px" fontWeight="bold">
                        {Loc.currentLang.myPlan.availableCredits}
                      </Text>
                      <Text
                        textAlign="center"
                        fontSize="xs"
                        color="coolGray.400"
                      >
                        {Loc.currentLang.myPlan.earnMoreCredits}
                      </Text>
                      <Button
                        mt={2}
                        w="full"
                        rounded="full"
                        bg="AVColor.primary"
                        _pressed={{ bg: "#289966" }} // pressed state
                        onPress={() => {
                          setIsBuyStorage(false);
                          setShowCreditsPopup(true);
                        }}
                      >
                        {Loc.currentLang.manageConversation.buyMoreCredits}
                      </Button>
                    </VStack>
                  </Box>

                  {/* Storage Card */}
                  <Box
                    flex={1}
                    borderWidth={1}
                    borderColor="coolGray.200"
                    borderRadius="xl"
                    p={3}
                    bg="white"
                    shadow={1}
                  >
                    <VStack space={3}>
                      <Text fontSize="md" fontWeight="bold">
                        {Loc.currentLang.myPlan.storage}
                      </Text>

                      {/* Progress */}
                      <Text fontSize="sm" fontWeight="medium">
                        <Text fontSize="12px" fontWeight="bold">
                          {formatBytes(
                            finalEntity?.totalFileSize +
                              finalEntity?.totalPostSize ?? 0,
                          )}{" "}
                        </Text>
                        <Text fontSize="xs" color="coolGray.400">
                          {" "}
                          {Loc.currentLang.myPlan.ofShared}{" "}
                          {formatBytes(finalEntity?.plan?.storeLimit ?? 0)}
                        </Text>
                      </Text>
                      <Progress
                        value={
                          ((finalEntity?.plan?.storeUsed ?? 0) /
                            (finalEntity?.plan?.storeLimit ?? 1)) *
                          100
                        }
                        size="sm"
                        _filledTrack={{ bg: "#00A7BC" }}
                      />

                      {/* Info + Label */}
                      <HStack alignItems="center" mt={1}>
                        {/*<Icon*/}
                        {/*  as={() => <AiOutlineInfoCircle />}*/}
                        {/*  size="sm"*/}
                        {/*  color="coolGray.400"*/}
                        {/*  mr={1}*/}
                        {/*/>*/}
                        {/*<Text fontSize="xs" color="coolGray.400">*/}
                        {/*  {" "}*/}
                        {/*  {Loc.currentLang.myPlan.useCreditsInfo}*/}
                        {/*</Text>*/}

                        {/* Navigation to donation page */}
                        <Pressable onPress={() => navigate("/donate")}>
                          <Text fontSize="14px" color="blue.500" underline>
                            {Loc.currentLang.purchaseCredits.donationLink}
                          </Text>
                        </Pressable>
                      </HStack>

                      <Text fontSize="sm" fontWeight="medium" mt={1}>
                        {Loc.currentLang.myPlan.dataStorageYourDevice}
                      </Text>

                      {/* Breakdown */}
                      <Divider my={2} />
                      {/* Individual Storage Breakdown */}
                      <HStack justifyContent="space-between">
                        <Text fontSize="sm">
                          {Loc.currentLang.myPlan.postGB}
                        </Text>
                        <Text fontSize="sm">
                          {formatBytes(
                            entity?.totalPostSize ??
                              currentUser?.totalPostSize ??
                              0,
                          )}
                        </Text>
                      </HStack>
                      <HStack justifyContent="space-between">
                        <Text fontSize="sm">
                          {Loc.currentLang.myPlan.albumsAndDocs}
                        </Text>
                        <Text fontSize="sm">
                          {formatBytes(
                            entity?.totalFileSize ??
                              currentUser?.totalFileSize ??
                              0,
                          )}
                        </Text>
                      </HStack>
                      <Button
                        mt={2}
                        w="full"
                        rounded="full"
                        bg="AVColor.primary"
                        _pressed={{ bg: "#289966" }} // pressed state
                        onPress={() => {
                          setIsBuyStorage(true);
                          setShowCreditsPopup(true);
                        }}
                      >
                        {Loc.currentLang.myPlan.buyMoreStorage}
                      </Button>
                    </VStack>
                  </Box>
                </HStack>
              )}

              {/* Shared Plan Section */}
              {sharedPlan && (
                <HStack
                  justifyContent="space-between"
                  alignItems="center"
                  mt={6}
                >
                  <SharedPlanCard />
                </HStack>
              )}
            </VStack>
          </>
        )}
      </Box>

      {/* Share My Plan and Manage Plan Popup */}
      {showShareMyPlanPopup && (
        <Box
          position="fixed"
          bg="AVColor.overlay2"
          bottom={0}
          right={0}
          top={0}
          left={0}
        >
          <div
            className={`create_post_popup ${mobile && "create_post_popup_mobile"}`}
            style={{
              width: mobile ? dimensions.width - 15 : 500,
              height: 200,
              marginTop: 12,
            }}
          >
            <VStack margin="24px" width="auto">
              <Text fontSize={"24px"} fontWeight={400}>
                {isManagePlan
                  ? Loc.currentLang.myPlan.managePlan
                  : Loc.currentLang.myPlan.shareMyplan}
              </Text>
              <VStack
                marginTop="15px"
                space={3}
                flexWrap={mobile ? "wrap" : "nowrap"}
              >
                <HStack
                  width="100%"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Text fontSize="18px" fontWeight={400}>
                    {Loc.currentLang.myPlan.selectShareType}
                  </Text>
                  <HStack width={"60%"} marginLeft={"10px"}>
                    <FormControl fullWidth>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={shareTypeValue}
                        onChange={(e) => setShareTypeValue(e.target.value)}
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: 300,
                            },
                          },
                        }}
                      >
                        {[
                          { label: Loc.currentLang.myPlan.none, value: "none" },
                          {
                            label: Loc.currentLang.myPlan.allowAll,
                            value: "A",
                          },
                          { label: Loc.currentLang.myPlan.noTxt, value: "NT" },
                          {
                            label: Loc.currentLang.myPlan.noBoost,
                            value: "NB",
                          },
                        ].map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </HStack>
                </HStack>

                {/*<HStack*/}
                {/*  width="100%"*/}
                {/*  justifyContent="flex-start"*/}
                {/*  alignItems="center"*/}
                {/*>*/}
                {/*  <Checkbox*/}
                {/*    value="autoShareChild"*/}
                {/*    isChecked={isAutoShareChild}*/}
                {/*    onChange={(value) => setIsAutoShareChild(value)}*/}
                {/*    accessibilityLabel={*/}
                {/*      Loc.currentLang.myPlan.autoShareWithChildOrgs*/}
                {/*    }*/}
                {/*    size="sm"*/}
                {/*  >*/}
                {/*    <Text ml={2}>*/}
                {/*      {Loc.currentLang.myPlan.autoShareWithChildOrgs}*/}
                {/*    </Text>*/}
                {/*  </Checkbox>*/}
                {/*</HStack>*/}
              </VStack>

              <HStack
                marginTop={"6%"}
                space={5}
                justifyContent={isMobile ? "flex-start" : "center"}
                alignSelf="center"
                flexWrap="wrap"
                maxWidth="100%"
              >
                <Button
                  rounded="full"
                  width="140px"
                  height="40px"
                  paddingTop="5px"
                  paddingBottom="5px"
                  backgroundColor="gray.300"
                  onPress={() => setShowShareMyPlanPopup(false)}
                >
                  <Text fontSize="16px" color="black">
                    {Loc.currentLang.myPlan.cancel}
                  </Text>
                </Button>

                <Button
                  rounded="full"
                  width="180px"
                  height="40px"
                  paddingTop="5px"
                  paddingBottom="5px"
                  backgroundColor="AVColor.primary"
                  isLoading={isAPICall}
                  isDisabled={isAPICall}
                  onPress={() =>
                    isManagePlan
                      ? handleSaveSharedPlan(
                          sharedPlan ?? ({} as AV.ISharedPlan),
                        )
                      : handleSharePlan()
                  }
                >
                  <Text color="white">
                    {isManagePlan
                      ? Loc.currentLang.myPlan.update
                      : Loc.currentLang.myPlan.createSharedPlan}
                  </Text>
                </Button>
              </HStack>
            </VStack>
          </div>
        </Box>
      )}

      {/* Add Share My Plan Popup */}
      {showAddSharePopup && (
        <Box
          position="fixed"
          bg="AVColor.overlay2"
          bottom={0}
          right={0}
          top={0}
          left={0}
        >
          <div
            className={`create_post_popup ${mobile && "create_post_popup_mobile"}`}
            style={{
              width: mobile ? dimensions.width - 15 : 550,
              height: "auto",
              marginTop: 12,
            }}
          >
            <VStack margin="24px" width="auto">
              <Text fontSize="24px" fontWeight={400}>
                {Loc.currentLang.myPlan.shareMyplan}
              </Text>

              <VStack marginTop="15px" space={3}>
                <Text>
                  {Loc.currentLang.myPlan.addPeopleOrgs} {" :"}
                </Text>

                {/* Search input */}
                <HStack justifyContent="space-between" alignItems="center">
                  <Input
                    width={isMobile ? "200px" : "400px"}
                    height="34px"
                    borderWidth={0}
                    value={searchQuery}
                    placeholder={Loc.currentLang.myPlan.search}
                    variant="AVSearchInput"
                    placeholderTextColor="AVColor.textLite"
                    backgroundColor="#F5F5F5"
                    borderRadius="22px"
                    fontSize="16px"
                    InputLeftElement={
                      <SearchIcon ml="2" size="24px" color="#000" />
                    }
                    InputRightElement={
                      searchQuery ? (
                        <IconButton
                          icon={<CloseIcon size="xs" />}
                          size="sm"
                          variant="AVSearchInput"
                          onPress={() => {
                            setSearchQuery("");
                            setSearchResults([]);
                            setSuggestions([]);
                          }}
                          _hover={{ bg: "transparent" }}
                        />
                      ) : undefined
                    }
                    onChangeText={handleSearchItems}
                  />

                  {/*<Button*/}
                  {/*  size="sm"*/}
                  {/*  width="80px"*/}
                  {/*  rounded="full"*/}
                  {/*  backgroundColor="AVColor.primary"*/}
                  {/*  isDisabled={selectedOrgs.length === 0}*/}
                  {/*>*/}
                  {/*  {Loc.currentLang.myPlan.add}*/}
                  {/*</Button>*/}
                </HStack>

                {/* Selected Orgs */}
                {selectedOrgs.length > 0 && (
                  <VStack space={2} mt={2}>
                    {selectedOrgs.map((org) => (
                      <HStack
                        key={org.id}
                        alignItems="center"
                        borderWidth={1}
                        borderColor="coolGray.300"
                        px={3}
                        py={1}
                        borderRadius="md"
                        justifyContent="space-between"
                      >
                        <HStack space={3} alignItems="center">
                          {org?.type === "Person" ? (
                            <ProfilePic
                              width="32px"
                              height="32px"
                              link={
                                currentUser && currentUser.id === org?.id
                                  ? AV.AVEntity.getLink(currentUser)
                                  : (() => {
                                      const entity = entityDataList?.find(
                                        (x) => x?.id === org?.id,
                                      );
                                      return entity
                                        ? AV.AVEntity.getLink(entity)
                                        : org;
                                    })()
                              }
                            />
                          ) : (
                            <EntityProfilePic
                              width="35px"
                              height="35px"
                              link={(() => {
                                const entity = entityDataList?.find(
                                  (x) => x?.id === org?.id,
                                );
                                return entity
                                  ? (AV.AVEntity.getLink(entity) ?? {
                                      ...org,
                                      type: org?.type,
                                    })
                                  : org;
                              })()}
                            />
                          )}

                          <VStack>
                            <Text fontWeight="medium">{org.title}</Text>
                            {org.data && org.type !== "Channel" && (
                              <Text fontSize="xs" color="gray.500">
                                {org.data}
                              </Text>
                            )}
                          </VStack>
                        </HStack>
                        <IconButton
                          icon={<CloseIcon size="xs" />}
                          onPress={() => org.id && handleRemoveOrg(org.id)}
                        />
                      </HStack>
                    ))}
                  </VStack>
                )}

                {/* Suggestions Dropdown */}
                {searchResults.length > 0 && (
                  <Box
                    position="absolute"
                    top="70px"
                    left={0}
                    right={0}
                    bg="white"
                    borderRadius="md"
                    mt={1}
                    shadow={4}
                    zIndex={1000}
                    maxH="300px"
                    overflowY="scroll"
                  >
                    {searchResults.map((org) => (
                      <Pressable
                        key={org.id}
                        onPress={() => handleOrgSelect(org)}
                        p={3}
                        _hover={{ bg: "gray.50" }}
                      >
                        <HStack space={3} alignItems="center">
                          {org?.type === "Person" ? (
                            <ProfilePic width="32px" height="32px" link={org} />
                          ) : (
                            <EntityProfilePic
                              width="35px"
                              height="35px"
                              link={org}
                            />
                          )}

                          <VStack>
                            <Text fontWeight="medium">{org.title}</Text>
                            {org.data && org.type !== "Channel" && (
                              <Text fontSize="xs" color="gray.500">
                                {org.data}
                              </Text>
                            )}
                          </VStack>
                        </HStack>
                      </Pressable>
                    ))}
                  </Box>
                )}
              </VStack>

              {/* Footer Buttons */}
              <HStack
                mt="6%"
                space={5}
                justifyContent={isMobile ? "flex-start" : "center"}
                alignSelf="center"
                zIndex="-3"
              >
                <Button
                  rounded="full"
                  width="140px"
                  height="40px"
                  backgroundColor="gray.300"
                  onPress={() => {
                    clearSearch();
                    setShowAddSharePopup(false);
                  }}
                >
                  <Text fontSize="16px" color="black">
                    {Loc.currentLang.myPlan.cancel}
                  </Text>
                </Button>

                <Button
                  width="180px"
                  rounded="full"
                  height="40px"
                  backgroundColor="AVColor.primary"
                  isLoading={isAPICall}
                  isDisabled={isAPICall || selectedOrgs.length === 0}
                  onPress={() => handleShareWith()}
                >
                  <Text color="white">{Loc.currentLang.myPlan.save}</Text>
                </Button>
              </HStack>
            </VStack>
          </div>
        </Box>
      )}

      {/* Credits Popup */}
      {showCreditsPopup && (
        <PurchaseCreditsPopup
          entity={entity}
          setEntity={setEntity}
          sharedPlan={sharedPlan}
          setSharedPlan={setSharedPlan}
          showCreditsPopup={showCreditsPopup}
          setShowCreditsPopup={setShowCreditsPopup}
          triggerBuyCredits={triggerBuyCredits}
          setTriggerBuyCredits={setTriggerBuyCredits}
          isBuyStorage={isBuyStorage}
        />
      )}

      {/* Confirmation Popup */}
      {isConfirm && (
        <ConfirmationPopup
          type={confirmType}
          isAPICall={isAPICall}
          onClose={() => setIsConfirm(false)}
          onConfirm={
            confirmType === "StopShare" || confirmType === "LeaveShare"
              ? handleStopShare
              : handleUnshare
          }
        />
      )}
    </>
  );
}

export default MyPlan;
